import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { useState } from 'react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../../../shared/components/TableSkeleton';
import { buildTrailerColumns } from '../components/build-trailer-columns';
import { CreateTrailerDrawer } from '../components/CreateTrailerDrawer';
import { TrailersTable } from '../components/TrailersTable';
import { useTrailers } from '../hooks/use-trailers';

export function TrailersPage() {
  const { state, list, isRefreshing, createError, creating, create, resetCreateError } = useTrailers();
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  const columns = buildTrailerColumns({ list });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-end">
        <Button
          type="primary"
          icon={<Plus className="size-4" />}
          onClick={() => {
            resetCreateError();
            setDrawerOpen(true);
          }}
        >
          Create trailer
        </Button>
      </div>
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load trailers" description="Something went wrong loading the trailers list. Try reloading the page." />
      )}
      {state.status === 'loading' && <TableSkeleton label="Loading trailers" withSearch />}
      {state.status === 'loaded' && <TrailersTable page={state.page} columns={columns} list={list} isRefreshing={isRefreshing} />}
      <CreateTrailerDrawer open={drawerOpen} error={createError} submitting={creating} onCreate={create} onClose={() => setDrawerOpen(false)} />
    </div>
  );
}
